import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useStudents = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchStudents = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/students`);
      setStudents(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching students:', err);
      setError('Failed to load students');
    } finally {
      setLoading(false);
    }
  }, []);

  const createStudent = async (studentData) => {
    const response = await axios.post(`${API}/students`, studentData);
    setStudents(prev => [...prev, response.data]);
    return response.data;
  };

  const updateStudent = async (studentId, studentData) => {
    const response = await axios.put(`${API}/students/${studentId}`, studentData);
    setStudents(prev => prev.map(s => s.id === studentId ? response.data : s));
    return response.data;
  };

  const deleteStudent = async (studentId) => {
    await axios.delete(`${API}/students/${studentId}`);
    setStudents(prev => prev.filter(s => s.id !== studentId));
  };

  const getStudent = async (studentId) => {
    const response = await axios.get(`${API}/students/${studentId}`);
    return response.data;
  };

  const getStudentRubrics = async (studentId) => {
    const response = await axios.get(`${API}/students/${studentId}/rubrics`);
    return response.data;
  };

  useEffect(() => {
    fetchStudents();
  }, [fetchStudents]);

  return {
    students,
    loading,
    error,
    fetchStudents,
    createStudent,
    updateStudent,
    deleteStudent,
    getStudent,
    getStudentRubrics
  };
};
